import React from 'react';
import S from './style/Dac7AddItemButton';

interface Props {
  label: string;
  onClick: () => void;
}

const renderIcon = () => <S.AddIcon />;

const Dac7AddItemButton = ({ label, onClick }: Props) => (
  <S.AddButtonContainer className="dac7_add-item-button">
    <S.StyledButtonSecondaryDark size="small" onClick={onClick} renderIcon={renderIcon}>
      <S.StyledParagraph3>{label}</S.StyledParagraph3>
    </S.StyledButtonSecondaryDark>
  </S.AddButtonContainer>
);

export default Dac7AddItemButton;
